<template>
  <SvgIcon />
</template>

<script setup lang="ts">
  type Icon = ''
  const props = defineProps({
    name: {
      type: String as PropType<Icon>
    }
  })

  const name = props.name?.toLowerCase()
  const SvgIcon = defineAsyncComponent(async () => {
    try {
      return await import(`../public/resources/images/icons/${name}.svg?component`)
    } catch (e) {
      console.error(`Error importing icon ${name}.svg`)
    }
  })
</script>